import { motion } from "framer-motion";
import { BUSINESS } from "@/data/site";
import { scrollToId } from "@/lib/scroll";
import Icon from "@/components/Icon";
import { Reveal } from "@/components/Reveal";
import { useLang } from "@/i18n";

export default function CTASection() {
    const { t } = useLang();
    return (
        <section data-testid="cta-section" className="relative py-24 md:py-36 overflow-hidden">
            <div className="absolute inset-0 bg-gradient-to-br from-electric via-[#0A4FD6] to-[#061A33]" />
            <div
                className="absolute inset-0"
                style={{ background: "radial-gradient(circle at 80% 110%, rgba(255,210,31,0.28), transparent 50%)" }}
            />
            <div className="absolute inset-0 circuit-bg opacity-30" />
            <div className="absolute top-[20%] left-[15%] w-2 h-2 rounded-full bg-white/70 animate-pulse-dot" />
            <div className="absolute top-[60%] right-[12%] w-1.5 h-1.5 rounded-full bg-solar animate-pulse-dot" style={{ animationDelay: "0.8s" }} />
            <div className="absolute bottom-[18%] left-[40%] w-1.5 h-1.5 rounded-full bg-cyan2 animate-pulse-dot" style={{ animationDelay: "1.5s" }} />

            <div className="relative max-w-5xl mx-auto px-6 md:px-12 text-center">
                <Reveal>
                    <h2 className="font-heading text-3xl sm:text-4xl md:text-6xl font-bold tracking-tight text-white leading-[1.1]">
                        {t.cta.heading}
                    </h2>
                    <p className="mt-6 text-lg md:text-xl text-white/80">
                        {t.cta.sub}
                    </p>
                </Reveal>
                <Reveal delay={0.15}>
                    <div className="mt-12 flex flex-wrap justify-center items-center gap-5">
                        <motion.a
                            data-testid="cta-call-now"
                            href={BUSINESS.tel}
                            whileHover={{ scale: 1.04 }}
                            whileTap={{ scale: 0.96 }}
                            className="inline-flex items-center gap-3 rounded-full bg-white px-10 py-5 font-heading font-bold text-lg text-[#07111F] shadow-[0_20px_60px_rgba(0,0,0,0.35)]"
                        >
                            <Icon name="phone" size={22} className="text-electric" />
                            {t.cta.call} {BUSINESS.phoneDisplay}
                        </motion.a>
                        <motion.button
                            data-testid="cta-send-enquiry"
                            onClick={() => scrollToId("contact")}
                            whileHover={{ scale: 1.04 }}
                            whileTap={{ scale: 0.96 }}
                            className="inline-flex items-center gap-2 rounded-full border-2 border-white/50 px-10 py-[1.1rem] font-semibold text-white hover:bg-white/10 transition-colors duration-300"
                        >
                            {t.cta.enquiry}
                            <Icon name="arrow" size={18} />
                        </motion.button>
                    </div>
                </Reveal>
            </div>
        </section>
    );
}
